// This file will eventually be type.ts
import { RouteProps } from 'react-router-dom';
import { PACKAGES } from './constants';

type PackageDetails = {
  displayName: string;
  isOverageable: boolean;
  isPaid: boolean;
  label: string;
  tier: number;
};

type Currency = {
  code: string;
};

export type PricingRouteProps = {
  redirectPath?: string;
} & RouteProps;

export type PackageSkuCost = {
  skuType: string;
  cost: number;
  currency: Currency;
};

export type PackageSkuCosts = PackageSkuCost[];

export type PackageProps = {
  ctaLabel: keyof typeof CTA_LABEL;
  package: string;
  packageName?: keyof typeof PACKAGES;
  details: PackageDetails;
  skuCost: PackageSkuCosts;
  ribbonText?: string | boolean | null;
  features: FeatureSet;
};

export type PackagePriceProps = {
  packageName: string;
  formattedPrice: string;
};

export type BylineProps = {
  byline?: string | null;
  packageName: string;
};

export type PackageHeaderProps = {
  ctaLabel: keyof typeof CTA_LABEL;
  packageName: string;
  details: PackageDetails;
  skuCosts: PackageSkuCosts;
  packageType: string;
};

export enum CTA_LABEL {
  SELECT = 'SELECT',
  YOUR_PLAN = 'YOUR_PLAN',
  NOT_UPGRADEABLE = 'NOT_UPGRADEABLE',
  SIGN_UP = 'SIGN_UP',
}
export type PackageData = {
  bundle: [];
  details: PackageDetails;
  encryptedCtaParam: string;
  featureSetId: string;
  id: string;
  features: FeatureSet;
  package: string;
  skuCost: PackageSkuCosts;
  ctaLabel: keyof typeof CTA_LABEL;
};

export type PackageDataSet = PackageData[];

export type PackageSet = string[];

export type FeatureSet = Feature[];

export type Feature = {
  name: string;
  amount?: number | null;
  isEnabled?: boolean | null;
  setting?: string | null;
};

export type PricingData = {
  packageData: PackageDataSet;
  packageSet: PackageSet;
};

export type PackageListProps = {
  packages: PackageData;
  packageSet: PackageSet;
};

// The properties for a summary/detail feature line item
export type DisplayFeatureStatic = {
  summary?: string;
  tooltipHeading?: string;
  tooltip?: string;
} | null;

export type SummaryDisplayFeatureList = DisplayFeatureStatic[];

export type SummaryFeatureMapCompoundItem = {
  featureItemKey: string;
  features?: string[];
};

export type SummaryFeatureMapItem = {
  [P in keyof SummaryFeatureMapCompoundItem]: SummaryFeatureMapCompoundItem[P];
};

export type FeatureSetMap = {
  [key: string]: Feature;
};

export type FeatureTransformerOptions = {
  locale?: string;
  packageName?: string;
};

export type SummaryFeatureRule = (
  featureValues: Record<string, Feature>,
  options: FeatureTransformerOptions
) => DisplayFeatureStatic;

export type SummaryFeatureRuleMap = Record<string, SummaryFeatureRule>;

export enum PackageType {
  Individual = 'individual',
  Teams = 'teams',
  Enterprise = 'enterprise',
}

export type NavRouteParams = {
  canonicalPath: string;
  subPath: string;
};

export type DetailsFeatureValueType = number | string | boolean | undefined | null;

export type DetailsFeatureRowPackages = {
  packageName: string;
  value: DetailsFeatureValueType;
};

export type DetailsFeatureRowFeature = {
  feature: string;
  summary?: string | undefined;
  tooltip?: string | undefined;
  tooltipHeading?: string | undefined;
  packages: DetailsFeatureRowPackages[];
};

export type DetailsFeatureRow = {
  name: string;
  features: DetailsFeatureRowFeature[];
};

export type DetailsFeatureSets = DetailsFeatureRow[];

export type FeaturesCategoryGroup = {
  category: string;
  features: string[];
};

export type DisplayFeatureRule = (featureValues: Record<string, Feature>) => DisplayFeatureStatic;

export type DisplayFeatures = Record<string, DisplayFeatureStatic>;

export type DisplayFeature = DisplayFeatureRule | DisplayFeatureStatic;

export type DisplayFeaturesUnion = Record<string, DisplayFeatureStatic | DisplayFeatureRule>;

export type CopyItem = {
  defaultMessage: string;
  desc: string;
  id: string;
};

export type Copy = {
  [key: string]: CopyItem;
};
